/* Preserve the theme preview when following a color link. */
(() => {
  const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
  if (!previewId) return;
  const updateLink = (link) => {
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    url.searchParams.set('preview_theme_id', previewId);
    link.href = url.href;
  };
  document.querySelectorAll('[data-chase-color-swatches] a').forEach(updateLink);
  ['click', 'auxclick', 'contextmenu', 'pointerdown'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const link = event.target.closest?.('[data-chase-color-swatches] a');
      if (link) updateLink(link);
    }, true);
  });
})();
